"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _react = require("react");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _useDidUpdateEffect = _interopRequireDefault(require("../../customHooks/useDidUpdateEffect"));

var ToggleLogic = function ToggleLogic(_ref) {
  var initialState = _ref.initialState,
      onToggle = _ref.onToggle,
      onReset = _ref.onReset,
      children = _ref.children;

  var _useState = (0, _react.useState)(initialState),
      on = _useState[0],
      setOn = _useState[1];

  var toggle = /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", setOn(function (currentOn) {
                return !currentOn;
              }));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function toggle() {
      return _ref2.apply(this, arguments);
    };
  }();

  var toggleOn = function toggleOn() {
    return setOn(true);
  };

  var toggleOff = function toggleOff() {
    return setOn(false);
  };

  (0, _useDidUpdateEffect["default"])(function () {
    return onToggle(on);
  }, [on, onToggle]);

  var reset = function reset() {
    setOn(initialState);
    onReset();
  };

  var getStateAndHelpers = function getStateAndHelpers() {
    return {
      on: on,
      toggle: toggle,
      reset: reset,
      toggleOn: toggleOn,
      toggleOff: toggleOff
    };
  };

  return children(getStateAndHelpers());
};

ToggleLogic.propTypes = {
  initialState: _propTypes["default"].bool,
  onToggle: _propTypes["default"].func,
  onReset: _propTypes["default"].func,
  children: _propTypes["default"].func.isRequired
};
ToggleLogic.defaultProps = {
  initialState: false,
  onToggle: function onToggle() {},
  onReset: function onReset() {}
};
var _default = ToggleLogic;
exports["default"] = _default;